import type { ReactNode } from "react";

/**
 * The one page-title pattern (spec §5.3): eyebrow, 24px title with mono meta,
 * one summary line, and a right-hand action slot.
 *
 * Every page SP1 touches routes through this instead of the ad hoc
 * uppercase-label plus 22px div each had grown its own version of.
 */
export function PageHeader({
  eyebrow,
  title,
  meta,
  summary,
  actions,
}: {
  eyebrow?: ReactNode;
  title: ReactNode;
  meta?: ReactNode;
  summary?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="page-header">
      <div className="page-header__main">
        {eyebrow ? <div className="page-header__eyebrow uppercase-label">{eyebrow}</div> : null}
        <div className="page-header__title-row">
          <h1 className="page-header__title">{title}</h1>
          {meta ? <span className="page-header__meta mono">{meta}</span> : null}
        </div>
        {summary ? <div className="page-header__summary">{summary}</div> : null}
      </div>
      {actions ? <div className="page-header__actions">{actions}</div> : null}
    </header>
  );
}
